import { useState } from "react";
import SimpleModal from "../../../components/Modal/SimpleModal/SimpleModal";
import classes from "./PayPopup.module.css";
import { showSavedPopup } from "../../../store/PopupsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { buyExperienceCash } from "../../../utils/api";

const PayPopup = ({ closeModalHandler, selectedExp, active, updateGuestList }) => {
  const { orgData } = useSelector((state) => state.orgData);
  const [buttonStatus, setButtonStatus] = useState("active");
  const dispatch = useDispatch();
  const { eventId } = useParams();
  const orgId = orgData.org.orgId;

  const payExpHandler = async () => {
    setButtonStatus("submitting");
    const experience = {
      experienceId: selectedExp.experience_id,
      eventId: eventId,
      orgId: orgId,
    };
    buyExperienceCash(experience)
      .then(() => {
        setButtonStatus("active");
        updateGuestList(experience);
        closeModalHandler();
      })
      .catch(() => setButtonStatus("active"));
  };

  return (
    <>
      <SimpleModal active={active} closeModalHandler={closeModalHandler}>
        <div className={classes.popup}>
          <h2>Pay album for {selectedExp?.name}?</h2>
          <p>
            After clicking “Pay”, the guest will receive the album with all files to download and share. This action is
            subject to Floodin fees.
          </p>

          <div className={classes.btns}>
            <button onClick={closeModalHandler}>Cancel</button>
            <button className={classes[buttonStatus]} onClick={payExpHandler}>
              Pay
            </button>
          </div>
        </div>
      </SimpleModal>
    </>
  );
};

export default PayPopup;
